import PropTypes from 'prop-types';
import React, { useState } from 'react';
// import { Row, Col, Button, Alert, Card, Spinner } from 'react-bootstrap';

// import * as Yup from 'yup';
// import { Formik } from 'formik';
import { NavLink, useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { Card, CircularProgress } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import CoverLayout from '../components/CoverLayout';;
import appImg from "assets/images/curved-images/application-img.png";
import logo from "assets/images/app-logo.jpeg"
import SoftAlert from "components/SoftAlert";
import SoftInput from 'components/SoftInput';
import SoftTypography from 'components/SoftTypography';

const OtpPage = () => {
	const [loading, setLoading] = useState(false);
	const [otp, setOtp] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	let { app_id } = useParams();

	let validateOTP = () => {

		if (!otp) {
			toast.error('Please input OTP');
			return;
		}
		if (!password) {
			toast.error('Please input password');
			return;
		}
		if (!confirmPassword) {
			toast.error('Please confirm your password');
			return;
		}
		if (password !== confirmPassword) {
			toast.error('Passwords do not match');
			return;
		}

		setLoading(true);

		const requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				application_id: app_id,
				otp: otp,
				password: confirmPassword
			}),
			redirect: 'follow'
		};

		fetch('https://api.losync.com/api/v1/application/new/password', requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setLoading(false);
				if (result?.status) {
					Cookies.set('accessT', result?.data?.access, { secure: true });
					Cookies.set('refreshT', result?.data?.refresh, { secure: true });
					toast.success(result?.message);
					setTimeout(() => {
						window.location.href = `${window.location.origin}/dashboard`;
					}, 2000);
				} else {
					toast.error(result?.message);
				}
			})
			.catch((error) => {
				setLoading(false);
				if (!error?.Success) {
					toast.error(error?.message);
				}
			});
	};
	return (

		<CoverLayout
			title="Application Form"
			description="input your OTP to finalize you application"
			image={appImg}
			logo={logo}
		>
			<SoftBox component="form" role="form">
				<SoftBox mb={1}>
					<SoftTypography component="label" variant="caption" fontWeight="bold">
						OTP
					</SoftTypography>
					<SoftInput
						value={otp}
						onChange={e => setOtp(e.target.value)}
						type="text"
						placeholder="123456"
					/>
				</SoftBox>
				<SoftBox mb={1}>
					<SoftTypography component="label" variant="caption" fontWeight="bold">
						Password
					</SoftTypography>
					<SoftInput
						type="password"
						onChange={e => setPassword(e.target.value)}
						placeholder="*******"
						value={password}
					/>
				</SoftBox>
				<SoftBox mb={1}>
					<SoftTypography component="label" variant="caption" fontWeight="bold">
						Confirm Password
					</SoftTypography>
					<SoftInput
						onChange={e => setConfirmPassword(e.target.value)}
						type="password"
						placeholder="*******"
						value={confirmPassword}
					/>
				</SoftBox>
				<SoftBox mt={2}>
					<SoftButton
						disabled={loading}
						variant="gradient"
						color="info"
						onClick={validateOTP}
					>
						{loading ? (
							<span>
								<CircularProgress color="inherit" />
								Loading...
							</span>
						) : (
							'Proceed'
						)}
					</SoftButton>
				</SoftBox>
			</SoftBox>
		</CoverLayout>
	);
};

// OtpPage.propTypes = {
//   className: PropTypes.string
// };

export default OtpPage;
